import {isNil} from 'ramda';

import {CompositionFont} from '@dms/api/sales';

import {compositionEditorLimits} from '../constants/compositionEditorLimits';

// Uploaded fonts are registered in the browser under a per-font family name so two uploads
// sharing the same family but differing in weight/style never collide.
export const getRegisteredFontFamily = (font: CompositionFont) => `composition-font-${font.id}`;

export const getCompositionFontFamily = (fontId: string | null, fonts: CompositionFont[]) => {
  const font = fonts.find((candidate) => candidate.id === fontId);
  const family = isNil(font)
    ? compositionEditorLimits.builtInFontFamily
    : getRegisteredFontFamily(font);
  return `'${family}', ${compositionEditorLimits.builtInFontFamily}, sans-serif`;
};
